module.exports = __webpack_public_path__ + "img/partner_premier.b60394da.jpeg";